import { useNavigate } from 'react-router-dom';
import { Box } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import * as actions from '../../../actions/Logradouro';
import SmartMapLegend from '../../../components/Map/SmartMapLegend';
import SmartMap, { mapKey } from '../../../components/Map/SmartMapFallback';
import { useAppDispatch } from '../../../store/hooks';

interface LogradouroMapProps {
  geoJson?: unknown;
}

export default function LogradouroMap({ geoJson }: LogradouroMapProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const identifyOnExtent = (geographicExtent: number[]) => {
    dispatch((actions as any).identifyOnExtent(geographicExtent, ({ data }: { data: number[] | null }) => {
      if (!data || data.length === 0) {
        notifications.show({ message: 'Nenhum logradouro encontrado.', color: 'yellow' });
      } else if (data.length === 1) {
        navigate(`/logradouro/visualizar/${data[0]}`);
      } else {
        navigate(`/logradouro?e=${JSON.stringify(geographicExtent).slice(1, -1)}`);
      }
    }));
  };

  return (
    <Box className="map-container" style={{ minHeight: 'calc(100vh - 310px)', position: 'relative' }}>
      <Box className="map-content" style={{ position: 'relative', flex: 1, minHeight: 400 }}>
        <SmartMap
          mapKey={mapKey.LOGRADOUROS}
          identifyOnExtent={identifyOnExtent}
          geoJson={geoJson}
          identifyOnPixelTolerance={5}
        />
      </Box>
      <Box className="legend-content">
        <SmartMapLegend />
      </Box>
    </Box>
  );
}
